import { AUDIENCE_FIELD_NAMES } from 'modules/projectSettings/constants';
import {
  ConfirmDisableAnonUserTrackingPayload,
  ProjectSettingsFormSchemaType,
  useProjectSettingsModalsContext,
} from 'modules/projectSettings/contexts';
import { useFormContext } from 'react-hook-form';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const CONFIRM_DISABLE_ANON_USER_TRACKING_MODAL_ID =
  'confirm-disable-anon-user-tracking-modal';

export const ConfirmDisableAnonUserTrackingModal = () => {
  const { modalState, hideModal } = useProjectSettingsModalsContext();
  const { resetField } = useFormContext<ProjectSettingsFormSchemaType>();

  const liveCriteraCount = modalState?.payload as ConfirmDisableAnonUserTrackingPayload;

  /** Reset the field value back to enabled if user clicks cancel button or clicks outside of the modal. */
  const handleCancel = () => {
    resetField(AUDIENCE_FIELD_NAMES.ENABLE_ANON_USER_TRACKING);
    hideModal();
  };

  return (
    <Modal
      id={CONFIRM_DISABLE_ANON_USER_TRACKING_MODAL_ID}
      isModalOpen={!!modalState}
      onClose={handleCancel}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader
        data-test={`${CONFIRM_DISABLE_ANON_USER_TRACKING_MODAL_ID}-header`}
        variant={MODAL_VARIANTS.WARNING}
      >
        Disable feature?
      </ModalHeader>
      <ModalBody>
        Are you sure you want to disable <strong>Unknown User Activation</strong>?
        <br /> <br />
        {`There ${liveCriteraCount === 1 ? 'is' : 'are'} `}
        <strong>{liveCriteraCount} anonymous criteria</strong>
        {` that ${liveCriteraCount === 1 ? 'is' : 'are'} live in this project.`}
        <br /> <br />
        By disabling this feature, all live criteria will be turned off and will need to be manually
        turned on if this feature is enabled again.
      </ModalBody>
      <ModalFooter onClose={handleCancel}>
        <DestructiveButton
          data-test={`${CONFIRM_DISABLE_ANON_USER_TRACKING_MODAL_ID}-disable-button`}
          onClick={hideModal}
          size={BUTTON_SIZES.LARGE}
        >
          Disable
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
